import { type Booking } from '../../../../../../../models/Scheduling'
import { useAppSelector } from '../../../../../../../store/hooks'
import { selectAccountId } from '../../../../../../../store/auth/authSlice'
import { useGetSchedulingEventTypesQuery, useGetSessionBookingsQuery } from '../../../../../../../store/scheduling/scheduling'

export interface FutureMeetingBookingsResult {
  bookings: Booking[]
  eventTypeNameById: Record<string, string>
  isLoading: boolean
}

export const useFutureMeetingBookings = (sessionId: string, roomId: string): FutureMeetingBookingsResult => {
  const accountId = useAppSelector(selectAccountId)
  const { data: bookings, isLoading: isBookingsLoading } = useGetSessionBookingsQuery({ accountId, sessionId, roomId })
  const { data: eventTypes, isLoading: isEventTypesLoading } = useGetSchedulingEventTypesQuery({ accountId })
  const eventTypeNameById = Object.fromEntries((eventTypes ?? []).map((eventType) => [eventType.id, eventType.name]))

  return { bookings: bookings ?? [], eventTypeNameById, isLoading: isBookingsLoading || isEventTypesLoading }
}
